import { titleCaseEquals } from '@src/utils/str';

export type Child =
  | string
  | {
      name: string;
      children?: Child[];
      [key: string]: unknown;
    };

export const getChildName = (child: Child) => {
  return typeof child === 'string' ? child : child?.name;
};

export const getMatchChild = (child: Child, name: string) => {
  const childName = getChildName(child);

  return titleCaseEquals(childName, name);
};

export const getFirstMatchedChild = (
  namesToMatch: string[],
  children: Child[]
): { name: string; index: number } | null => {
  if (!Array.isArray(namesToMatch) || namesToMatch.length === 0) return null;

  const [firstName, ...restNames] = namesToMatch;

  const isNameMatched = children.some((child) =>
    getMatchChild(child, firstName)
  );

  if (isNameMatched) {
    return {
      name: firstName,
      index: children.findIndex((child) => getMatchChild(child, firstName)),
    };
  } else if (restNames.length > 0) {
    return getFirstMatchedChild(restNames, children);
  } else {
    return null;
  }
};
